import { post } from 'axios';
import { ENDPOINT } from './../config/endpoints';
import apiCall from './api';

/**
 * Function for getting additional page
 * @param {string} slug
 * @param {number} storeId
 * @param {boolean} isPreview
 * @param {string} templateId
 * @param {number} pageType
 * @return {object}
 */
async function getAdditionalPage(slug, storeId, isPreview, templateId, pageType = 1) {
  if (!storeId) {
    return { error: 'invalid store ID' };
  }
  try {
    const response = await post(
      ENDPOINT.ADDITIONAL_PAGES.GET_ADDITIONAL_PAGE,
      {
        slug_url: slug,
        store_id: storeId,
        preview: isPreview,
        template_id: templateId,
        page_type: pageType,
      },
      {
        headers: {
          app_os: 'cfe',
        },
      }
    );

    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 *
 * @param {Number} storeId
 * @param {Boolean} isPublished
 * @returns {Promise<import('@/redux/reducers/additionalPages').AdditionalPageInfo[]>}
 */
export const getNavigationList = async (storeId, isPublished) => {
  const pageResponse = await apiCall({
    method: 'GET',
    url: ENDPOINT.ADDITIONAL_PAGES.getNavigationList(storeId, isPublished),
    parseToJson: true,
  });

  if (pageResponse && pageResponse.data.status) {
    return pageResponse.data.data;
  }
};

/**
 *
 * @param {Number} storeId
 * @param {Boolean} isPublished
 * @returns {Promise<import('@/redux/reducers/additionalPages').AdditionalPageInfo[]>}
 */
const getPublishedBlogs = async (storeId) => {
  const pageResponse = await apiCall({
    method: 'GET',
    url: ENDPOINT.ADDITIONAL_PAGES.getPublishedBlogs(storeId),
    parseToJson: true,
  });

  if (pageResponse && pageResponse.data.status) {
    return pageResponse.data.data;
  }
};

export { getAdditionalPage, getPublishedBlogs };
